import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { ActivityPipesModel } from '../models';

export function useActivityPipes() {
  const { data, ...arg } = useQuery<{ activityPipes: ActivityPipesModel[] }>(
    ['dashboard-v2-activity-pipes'],
    async () => {
      const { data } = await $api.get('/v1/activity-logs/pipes');

      return { activityPipes: data?.data?.body?.data };
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  return { ...data, ...arg };
}
